import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const handleError = (error) => {
  console.error('Client Node API Error:', error);

  if (error.response?.status === 503) {
    return {
      success: false,
      error: 'Service temporarily unavailable'
    };
  }

  if (error.response?.status === 401) {
    return {
      success: false,
      error: 'Unauthorized - Invalid credentials'
    };
  }

  if (error.response?.status === 400) {
    return {
      success: false,
      error: error.response?.data?.message || 'Bad request - Invalid data provided'
    };
  }

  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
};

export const assignNodeToClient = async ({ nodeId, clientId, token }) => {
  try {
    const response = await axios.post(`${BASE_URL}/compute-v2/v2/client/node`, {
      node_id: nodeId,
      client_id: clientId
    }, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'Node assigned to client successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const assignAllClientNodesToUser = async ({ clientId, userId, isSudo, token }) => {
  try {
    const response = await axios.post(`${BASE_URL}/compute-v2/v2/client/${clientId}/node`, {
      user_id: userId,
      is_sudo: isSudo
    }, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'All client nodes assigned to user successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const removeNodeFromClient = async ({ nodeId, clientId, token }) => {
  try {
    const response = await axios.delete(`${BASE_URL}/compute-v2/v2/client/${clientId}/node/${nodeId}`, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
      message: 'Node removed from client successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getClientNodes = async ({ clientId, token }) => {
  try {
    const response = await axios.get(`${BASE_URL}/compute-v2/v2/client/${clientId}/node`, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'x-auth-user': token
      }
    });

    return {
      success: true,
      data: {
        nodeIds: response.data.node_ids || response.data.nodeIds || []
      },
      status: response.status,
      message: 'Client nodes retrieved successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

